import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    margin: "5px",
    // width: "100%",
    flexGrow: 1,
  },

  Grid: {
    padding: theme.spacing(2),
    maxWidth: 500,
    margin: "5px",
    justifyContent: "left",
    textAlign: "left",
  },

  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },

  paper: {
    padding: theme.spacing(2),
    margin: "auto",
    maxWidth: 500,
    borderRadius: "15px",
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      justifyContent: "center",
      width: "230px",
    },
  },

  image: {
    width: "150px",
    minHeight: " 120px",
    maxHeight: "auto",
    float: "left",
    margin: " 3px",
    padding: "3px",
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      justifyContent: "center",
      width: "250px",
      // width:'100%'
    },
  },
  img: {
    height: 130,
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      justifyContent: "center",
      width: 250,
      // width:'100%'
    },
  },

  description: {
    fontFamily: "SegoeUI-Light, Segoe UI",
    fontWeight: 300,
    width: 350,
    textAlign: "left",
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      justifyContent: "center",
      width: "100%",
    },
  },

  price: {
    textAlign: "right",
    fontSize: 12,
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      width: 260,
      fontSize: 15,
    },
  },
  calories: {
    textAlign: "left",
    fontSize: 12,
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      width: 260,
      fontSize: 15,
    },
  },
  linkButton: {
    fontFamily: "Gilroy-Light, serif",
    fontSize: "14px",
    textTransform: "capitalize",
    color: "#d62828",
    marginRight: "10px",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },

  viewMenu: {
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      width: 260,
      fontSize: 15,
    },
  },
  chip: {
    margin: 1,
    //justifyContent: "center",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
  menuInfo: {
    fontFamily: "Gilroy-ExtraBold, serif",
    color: "#000",
    fontSize: "1.5rem",
    display: "flex",
    justifyContent: "center",
    alignSelf: "center",
    marginTop: 25,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  menus: {
    width: "90%",
    marginTop: 20,
    marginLeft: 30,
    backgroundColor: "#FFFAF7",
    padding: 5,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginTop: 0,
      marginLeft: 0,
      padding: 0,
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      marginTop: 0,
      marginLeft: 0,
      padding: 0,
    },
  },
}));
